import { API } from "../urls";

export const getOnlineUsers = async () => {
    const res = await fetch(API.admin_online_users, {
        credentials: "include",
        headers: { "Content-Type": "application/json" },
    });
    if (!res.ok) throw new Error((await res.json().catch(() => ({}))).message || "Çevrimiçi kullanıcılar yüklenemedi");
    return res.json();
};
